import { useFrontendConfigContext as M } from "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "@apollo/client";
import "../../apostle-lib/deserializes/yup/apostle.js";
import { useMemo as j, useCallback as m, useEffect as F } from "react";
import * as i from "ramda";
import "../../temp-lib/util/i18n/helper/locale.js";
import "react-i18next";
import { CurrencyTokenType as N, CurrencyMoneyType as a, EMPTY_CURRENCY as O, WETH_REFRESH_CURRENCY_RATE_DURATION as B } from "../constants/currency.js";
import H from "../hooks/graphql/useGetCurrencyInfo.js";
import K from "../hooks/graphql/useGetTokenPriceToUSD.js";
import "../../temp-lib/styles/theme.js";
import "@mui/material";
import { jsx as $ } from "react/jsx-runtime";
import "../../temp-lib/legacy/header/Header.js";
import "../../temp-lib/legacy/infoAccordion/InfoAccordion.js";
import "../../temp-lib/legacy/layout/Layout.js";
import "../../temp-lib/legacy/nav/Nav.js";
import "@metamask/detect-provider";
import "../../temp-lib/legacy/util/provider/Web3Instance.js";
import "jsonwebtoken";
import "web3";
import "../../temp-lib/legacy/util/provider/WalletConnect.js";
import "../../download-lib/deserializes/yup/download.js";
import "../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import "../../temp-lib/components/account/adeptus/AdeptusSuccessPopup.js";
import "../../temp-lib/components/account/share/ConfirmButton.js";
import "../../temp-lib/components/account/share/FormControlledPassword.js";
import "i18next";
import "../../temp-lib/components/account/share/EmailOTPSender.js";
import "../../temp-lib/components/share/mui/Textfield.js";
import "react-hook-form";
import "../../temp-lib/components/account/share/ForgotPasswordButton.js";
import "../../temp-lib/components/account/share/PopupTitle.js";
import "../../temp-lib/components/account/share/SendEmailOTPButton.js";
import "../../temp-lib/components/footer/Footer.js";
import "../../temp-lib/components/role/EnoughRoleOnly.js";
import "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import "../../temp-lib/components/share/apeiron/ApeironButtonDisableTip.js";
import "../../temp-lib/components/share/apeiron/ApeironChickenPopup.js";
import "../../temp-lib/components/share/apeiron/ApeironCloseButton.js";
import "../../temp-lib/components/share/apeiron/ApeironCookieConsent.js";
import "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import "../../temp-lib/components/share/apeiron/ApeironGoToButton.js";
import "../../temp-lib/components/share/apeiron/ApeironImageButton.js";
import "../../temp-lib/components/share/apeiron/ApeironInfinityDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironReactPlayer.js";
import "../../temp-lib/components/share/apeiron/ApeironSectionTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTutorialDialog/ApeironTutorialDialog.js";
import "../../temp-lib/components/share/generic/CloseButton.js";
import "../../temp-lib/components/share/generic/IconText.js";
import "../../temp-lib/components/share/generic/ModalBox.js";
import "../../temp-lib/components/share/generic/Pagination.js";
import "../../temp-lib/components/share/generic/SearchEmptyState.js";
import "../../temp-lib/components/share/generic/Skeleton.js";
import "../../temp-lib/components/share/generic/TextInput.js";
import "next/script";
import "../../temp-lib/components/share/mui/Snackbar.js";
import "../../temp-lib/components/share/next/Image.js";
import "../../temp-lib/components/share/next/NextLink.js";
import "../../temp-lib/components/share/popup/InfoPopup.js";
import "../../temp-lib/constants/account.js";
import { ChainAddressType as l } from "../../temp-lib/constants/chain.js";
import "../../temp-lib/constants/googleAnalytics.js";
import "../../temp-lib/constants/query.js";
import "../../temp-lib/contexts/account/AccountContext.js";
import "../../temp-lib/contexts/account/Geetest4Context.js";
import "../../temp-lib/contexts/adeptus/AdeptusContext.js";
import "@apollo/client/link/error";
import "@apollo/client/utilities";
import "../../temp-lib/contexts/config/ConfigContext.js";
import "../../temp-lib/contexts/language/LanguageContext.js";
import "path";
import "query-string";
import "p-retry";
import "ramda-adjunct";
import "../../temp-lib/contexts/share/LogicControlContext.js";
import "../../temp-lib/contexts/fingerprint/FingerprintContext.js";
import "../../temp-lib/contexts/role/RoleContext.js";
import "../../temp-lib/contexts/share/DataGridContext.js";
import "../../temp-lib/contexts/share/MessageContext.js";
import "../../temp-lib/contexts/share/PersistQueryContext.js";
import "../../temp-lib/contexts/share/PreloadContext.js";
import "@tanstack/react-query";
import "../../temp-lib/contexts/share/ScreenLogContext.js";
import "../../temp-lib/contexts/web3/Web3Context.js";
import "../../wallet-lib/contexts/RoninNameServiceContext.js";
import "../../temp-lib/deserialize/yup/account.js";
import "../../temp-lib/deserialize/yup/chain.js";
import "../../temp-lib/deserialize/yup/locale.js";
import "../../temp-lib/deserialize/yup/page.js";
import "../../temp-lib/deserialize/yup/platform.js";
import "../../temp-lib/graphql/fragment/account.js";
import "date-fns";
import "date-fns/constants";
import "react-countdown";
import "next/router";
import "@walletconnect/utils";
import "@wagmi/core";
import "../../temp-lib/util/query/index.js";
import "../../temp-lib/deserialize/yup/adeptusCampaign.js";
import "../../temp-lib/graphql/query/getAdeptusCampaigns.js";
import "../../temp-lib/graphql/query/getPublicAccountDetail.js";
import "../../temp-lib/graphql/mutation/processEmailRegister.js";
import q from "../../temp-lib/hooks/web3/useWeb3.js";
import { createStrictContext as Q } from "../../temp-lib/util/context/createStrictContext.js";
import "i18next-http-backend";
import "react-i18next/initReactI18next";
import { formatNumberString as y, DETAIL_USD_OPTIONS as z } from "../../temp-lib/util/misc/formatNumberString.js";
import "../../temp-lib/util/yup/index.js";
import "../../temp-lib/wagmi/roninConnector.js";
import { erc20Abi as T } from "viem";
import J from "use-async-effect";
const [V, po] = Q("Currency"), so = (S) => {
  const {
    enabled: u = !1,
    children: I
  } = S, {
    config: R,
    waitConfig: P
  } = M(), {
    fromWei: f
  } = q(), {
    data: d,
    fetch: _
  } = H(), {
    data: C,
    fetch: A
  } = K(), U = j(() => {
    if (i.isNotNil(C)) {
      const r = (e) => {
        const c = i.find(i.propEq(e, "type"), C);
        return i.propOr(0, "ratio", c);
      }, t = Object.values(N), o = Object.values(a);
      let n = {};
      return i.forEach((e) => {
        let c = {};
        i.forEach((E) => {
          c = i.assoc(E, r(e), c);
        }, o), n = i.assoc(e, c, n);
      }, t), n;
    }
    return {};
  }, [C]), h = m((r) => {
    const t = i.values(d || {});
    return i.find((o) => (o == null ? void 0 : o.assetName) === r, t);
  }, [d]), p = m((r) => i.propOr(null, r || "", d), [d]), b = m((r) => {
    const t = p(r), o = {
      address: {
        [l.POLYGON]: (t == null ? void 0 : t.address) || "0x0",
        [l.RONIN]: (t == null ? void 0 : t.address) || "0x0"
      },
      abi: {
        [l.POLYGON]: T,
        [l.RONIN]: T
      },
      method: ""
    };
    return {
      GET_USER_BALANCE: {
        ...o,
        method: "balanceOf"
      },
      GET_USER_ALLOWANCE: {
        ...o,
        method: "allowance"
      },
      REQUEST_ALLOWANCE: {
        ...o,
        method: "approve"
      }
    };
  }, [p]), v = m((r) => {
    const t = p(r);
    return (t == null ? void 0 : t.address) || "0x0";
  }, [p]), g = m((r, t, o = {}) => {
    if (i.isNil(t))
      return O;
    const n = p(r), e = f(String(t), (n == null ? void 0 : n.decimals) || 0);
    return y(e, o);
  }, [f, p]), L = m((r, t = 18) => i.isNil(r) ? O : r === 0 ? "0" : y(String(r), {
    maxLength: 10,
    maxDecimal: t,
    minNumberWithoutENotation: 5e-11,
    allowENotation: !0,
    allowedLargeNumberAbbr: !1,
    priorities: ["maxLength", "maxDecimal"]
  }), []), W = m((r, t, o = {}) => {
    const n = g(r, t, o), e = p(r);
    return i.isNotNil(e) ? `${n} ${e.name}` : n;
  }, [g, p]), s = m((r = N.Weth, t = a.Usd) => i.pathOr(0, [r, t], U), [U]), k = m((r, t, o, n = {}) => {
    const e = p(r);
    if (i.isNil(e))
      return "0";
    const c = s(r || N.Weth, a.Usd), E = o ? f(String(t), e.decimals) : String(t), Y = c * parseFloat(E);
    return y(Y.toString(), {
      ...z,
      ...n
    });
  }, [f, p, s]), D = m((r, t, o) => {
    if (t === o)
      return r;
    const n = s(t, a.Usd), e = s(o, a.Usd);
    return e === 0 ? 0 : r * n / e;
  }, [s]), G = m((r, t) => {
    const o = s(t, a.Usd);
    return r * o;
  }, [s]), x = m((r) => {
    const t = i.pathOr([], ["supportToken", r], R);
    return i.is(Array, t) ? i.map((o) => h(o), t) : [];
  }, [R, h]), w = m((r) => i.head(x(r)), [x]);
  return F(() => {
    if (u) {
      A();
      const r = setInterval(A, B);
      return () => clearInterval(r);
    }
  }, [u]), J(async (r) => {
    if (u) {
      const t = await P();
      if (r()) {
        const o = (t == null ? void 0 : t.supportToken.allTokens) || {
          onChain: [],
          offChain: []
        };
        _(i.concat(o.offChain, [...o.onChain, "Item_ronin_erc20_0203"]));
      }
    }
  }, [u]), /* @__PURE__ */ $(V, {
    value: {
      getApeironPrice: g,
      getApeironDetailPrice: L,
      getApeironPriceWithUnit: W,
      getCurrencyByAssetName: h,
      getCurrency: p,
      getCurrencyAddress: v,
      getCurrencyContract: b,
      getExchangeRate: s,
      getUSDPrice: k,
      getDefaultSupportCurrency: w,
      convertCurrencyPrice: D,
      convertCurrencyToUsd: G
    },
    children: I
  });
};
export {
  so as CurrencyProvider,
  po as useCurrencyContext
};
//# sourceMappingURL=CurrencyContext.js.map
